"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const material_1 = require("@mui/material");
const pulse_components_1 = require("@pcs/pulse-components");
const react_redux_1 = require("react-redux");
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const lodash_1 = require("lodash");
const store_1 = require("../../store");
const selectors_1 = __importDefault(require("../../slice/selectors"));
const constants_1 = require("../../slice/sliceReview/constants");
const sliceReview_1 = require("../../slice/sliceReview");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const sliceTemplate_1 = require("../../slice/sliceTemplate");
const helper_1 = require("../../../reviews/helper");
const notification_1 = __importDefault(require("../../../reviews/constants/notification"));
const BtnPrevious = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { phase, isInsideProject, mode } = (0, react_redux_1.useSelector)(selectors_1.default);
    const { selectedTemplate } = (0, react_redux_1.useSelector)((state) => state.template);
    const isDisplayPreBtn = (0, react_1.useCallback)(() => {
        // we have three case to disable pre btn
        if (isInsideProject && constants_1.MODE.create === mode) {
            // start create inside project
            return phase !== constants_1.PHASE.selectOption;
        }
        if (!isInsideProject && constants_1.MODE.create === mode) {
            // start create outside project
            return phase !== constants_1.PHASE.startReview;
        }
        if (!isInsideProject && mode === constants_1.MODE.newRound) {
            return phase !== constants_1.PHASE.confirmCreateNewRound;
        }
        // always display preBtn when use template modal
        if (phase === constants_1.PHASE.templateSettings ||
            phase === constants_1.PHASE.updateTemplate ||
            phase === constants_1.PHASE.savingTemplate) {
            return mode === constants_1.MODE.share || mode === constants_1.MODE.update;
        }
        // start share for review or start for update
        return !(mode === constants_1.MODE.share || mode === constants_1.MODE.update);
    }, [phase, isInsideProject, mode]);
    const handleClick = () => {
        dispatch((0, sliceReview_1.previousModal)());
    };
    const handleDeleteTemplate = async () => {
        if (selectedTemplate) {
            await pulse_components_1.v2Endpoint
                .delete(`${helper_1.URLS.app}api/workflow-templates/${selectedTemplate.value}`)
                .then(() => {
                utilities_1.default.notification.success(notification_1.default.deletedTemplate);
            })
                .catch((err) => {
                utilities_1.default.notification.danger(err);
            });
            dispatch((0, sliceTemplate_1.closeTemplate)());
            dispatch((0, sliceReview_1.nextModal)());
        }
    };
    return isDisplayPreBtn() ? (react_1.default.createElement("div", { className: styles_modules_less_1.default['modal-footer__left'] },
        react_1.default.createElement(pulse_components_1.PulseButton, { icon: true, classes: [styles_modules_less_1.default['modal-footer__btn'], styles_modules_less_1.default['footer-left']], iconClasses: {
                root: (0, clsx_1.default)(styles_modules_less_1.default['footer-btn__icon'], styles_modules_less_1.default['footer-btn__icon--left']),
                icon: (0, clsx_1.default)('fal fa-angle-left', styles_modules_less_1.default['footer-btn__icon--lg']),
            }, onClick: handleClick, label: 'Back' }),
        phase === constants_1.PHASE.templateSettings && selectedTemplate && (react_1.default.createElement("span", { className: styles_modules_less_1.default['delete-template'], onClick: handleDeleteTemplate },
            react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-trash-alt', styles_modules_less_1.default['delete-template__icon']) }),
            react_1.default.createElement("span", { className: styles_modules_less_1.default['delete-template__text'] }, "Delete template"))))) : (react_1.default.createElement("div", null));
};
const BtnNext = ({ handleSubmit, handleNotifyLeastOneReviewer, handleNotifyMaxInstructionLength, }) => {
    const { phase, method, round, mode, allowNext, assets, currentStage, roundStages, } = (0, react_redux_1.useSelector)(selectors_1.default);
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const template = (0, react_redux_1.useSelector)(selectors_1.default);
    const getLabel = (0, react_1.useMemo)(() => {
        if (phase === constants_1.PHASE.reviewing) {
            let roundNumber = 1;
            if (round === null || round === void 0 ? void 0 : round.round_number) {
                roundNumber =
                    mode === constants_1.MODE.newRound
                        ? (round === null || round === void 0 ? void 0 : round.last_round_number) + 1
                        : round === null || round === void 0 ? void 0 : round.round_number;
            }
            return `${method.replace('-', ' ')}: round ${roundNumber}`;
        }
        return 'next';
    }, [phase, mode, round === null || round === void 0 ? void 0 : round.round_number]);
    const handleClick = () => {
        var _a, _b;
        if (allowNext) {
            if (phase === constants_1.PHASE.chooseUpload) {
                dispatch((0, sliceReview_1.uploadAsset)(assets));
                return;
            }
            if (phase === constants_1.PHASE.reviewing) {
                // validate unique stage name
                if ((0, helper_1.uniqueNameStages)(roundStages)) {
                    utilities_1.default.notification.danger(notification_1.default.uniqueStageName);
                    return;
                }
                // trigger notification danger that the Stages must have at least one Reviewer.
                if ((0, lodash_1.isFunction)(handleNotifyLeastOneReviewer))
                    handleNotifyLeastOneReviewer();
                if ((0, lodash_1.isFunction)(handleNotifyMaxInstructionLength))
                    handleNotifyMaxInstructionLength();
                handleSubmit();
                return;
            }
            if (mode === constants_1.MODE.newRound &&
                currentStage === constants_1.OPTION.previous &&
                phase !== constants_1.PHASE.savingTemplate) {
                dispatch((0, sliceReview_1.updatePhase)(constants_1.PHASE.reviewing));
                return;
            }
            if (phase === constants_1.PHASE.savingTemplate) {
                dispatch((0, sliceReview_1.openTemplateModal)(template.savingMethod));
                return;
            }
            if (phase === constants_1.PHASE.chooseUrl && mode === constants_1.MODE.create) {
                dispatch((0, sliceReview_1.nextModal)());
                return;
            }
            if (phase === constants_1.PHASE.chooseUrl && mode === constants_1.MODE.newRound) {
                dispatch((0, sliceReview_1.fetchRound)(round === null || round === void 0 ? void 0 : round.id));
                return;
            }
            // create a new template
            if (phase === constants_1.PHASE.templateSettings && !template.selectedTemplate) {
                if (template.templateName) {
                    const requestBody = (0, helper_1.parseRequestBodyTemplate)(roundStages, template);
                    dispatch((0, sliceTemplate_1.saveTemplate)(requestBody));
                    dispatch((0, sliceTemplate_1.closeTemplate)());
                }
                else {
                    dispatch((0, sliceTemplate_1.updateTemplateName)(''));
                    return;
                }
            }
            // edit a template
            if (phase === constants_1.PHASE.updateTemplate ||
                (phase === constants_1.PHASE.templateSettings && template.selectedTemplate)) {
                if (template.templateName) {
                    const requestBody = (0, helper_1.parseRequestBodyUpdateTemplate)(((_a = template.selectedTemplate) === null || _a === void 0 ? void 0 : _a.value) || '', template, phase === constants_1.PHASE.updateTemplate ? roundStages : undefined);
                    dispatch((0, sliceTemplate_1.updateTemplate)({
                        id: ((_b = template.selectedTemplate) === null || _b === void 0 ? void 0 : _b.value) || '',
                        template: requestBody,
                    }));
                    dispatch((0, sliceTemplate_1.closeTemplate)());
                }
                else {
                    dispatch((0, sliceTemplate_1.updateTemplateName)(''));
                    return;
                }
            }
            dispatch((0, sliceReview_1.nextModal)());
        }
    };
    return (react_1.default.createElement("section", { className: styles_modules_less_1.default['footer-right'] }, phase === constants_1.PHASE.templateSettings || phase === constants_1.PHASE.updateTemplate ? (react_1.default.createElement(pulse_components_1.PulseButton, { classes: [
            styles_modules_less_1.default['modal-footer__btn'],
            styles_modules_less_1.default['footer-right__item'],
            (0, clsx_1.default)(!allowNext
                ? styles_modules_less_1.default['footer-right__item--disable']
                : styles_modules_less_1.default['footer-right__item--base']),
        ], icon: true, iconPosition: 'left', color: pulse_components_1.Colors.success, iconClasses: {
            root: (0, clsx_1.default)(styles_modules_less_1.default['footer-btn__icon']),
            icon: (0, clsx_1.default)(styles_modules_less_1.default['footer-btn__icon--lg'], 'fal fa-save'),
        }, label: "Save template", onClick: handleClick })) : (react_1.default.createElement(pulse_components_1.PulseButton, { classes: [
            styles_modules_less_1.default['modal-footer__btn'],
            styles_modules_less_1.default['footer-right__item'],
            (0, clsx_1.default)(!allowNext
                ? styles_modules_less_1.default['footer-right__item--disable']
                : styles_modules_less_1.default['footer-right__item--base']),
        ], icon: true, iconPosition: phase !== constants_1.PHASE.reviewing ? 'right' : 'left', color: pulse_components_1.Colors.success, iconClasses: {
            root: (0, clsx_1.default)(styles_modules_less_1.default['footer-btn__icon'], styles_modules_less_1.default['footer-btn__icon--right']),
            icon: (0, clsx_1.default)(phase === constants_1.PHASE.reviewing
                ? ' fal fa-play-circle'
                : 'fal fa-angle-right', styles_modules_less_1.default['footer-btn__icon--lg']),
        }, onClick: handleClick, label: getLabel }))));
};
const FooterModal = ({ formikProps, handleNotifyLeastOneReviewer, handleNotifyMaxInstructionLength, }) => {
    const { handleSubmit } = formikProps;
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['modal-footer'] },
        react_1.default.createElement(material_1.Divider, { light: true }),
        react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['modal-footer__root']) },
            react_1.default.createElement(BtnPrevious, null),
            react_1.default.createElement(BtnNext, { handleSubmit: handleSubmit, handleNotifyLeastOneReviewer: handleNotifyLeastOneReviewer, handleNotifyMaxInstructionLength: handleNotifyMaxInstructionLength }))));
};
exports.default = FooterModal;
